import { useEffect, useState } from 'react';
import myLogo from '../assets/images/whiteBgColor.png';
import myLogo1 from '../assets/images/symbol1.svg';

const navLinks = [
  { label: 'Home', href: '/#home' },
  { label: 'Services', href: '/#services' },
  { label: 'Blog', href: '/blog' },
  { label: 'About', href: '/#about' },
  { label: 'Contact Us', href: '/#contact-info' }
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isMenuOpen]);

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const handleConnectClick = () => {
    window.dispatchEvent(new Event('open-connect'));
    setIsMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-colors ${isMenuOpen ? 'duration-0' : 'duration-300'} ${
        isScrolled && !isMenuOpen
          ? 'bg-gray-900 bg-opacity-80 navbar-blur border-b border-gray-700 border-opacity-50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex items-center space-x-2">
              <div className="flex-shrink-0">
                <img className="h-11 w-auto" src={myLogo} alt="VAISPtech logo" />
              </div>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-5">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-gray-300 hover:text-white px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="hidden md:block">
            <a
              href="/#connect"
              onClick={handleConnectClick}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-all duration-300 transform hover:scale-105 inline-flex items-center whitespace-nowrap"
            >
              Get a Quote
            </a>
          </div>

          <div className={`md:hidden transition-opacity duration-200 ${isMenuOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
            <button
              type="button"
              onClick={handleMenuToggle}
              className="text-gray-300 hover:text-white p-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
              aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={isMenuOpen}
            >
              {isMenuOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden fixed inset-0 z-[60]">
          <div
            className="absolute inset-0 z-0"
            onClick={handleLinkClick}
          >
            <div
              className="absolute inset-0"
              style={{
                backgroundColor: '#100f28',
                backgroundImage: 'radial-gradient(ellipse at center, rgba(79, 70, 229, 0.20) 0%, transparent 70%)'
              }}
            />
          </div>
          <div className="relative z-10 flex h-full flex-col">
            <div className="flex items-center justify-between px-6 pt-16">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 flex items-center justify-center ">
                  <img src={myLogo1} alt="VAISPtech logo" />
                </div>
              </div>
              <button
                type="button"
                onClick={handleMenuToggle}
                className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-indigo-500/40 bg-indigo-500/10 text-indigo-200 transition-all duration-200 hover:border-indigo-400 hover:bg-indigo-500/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
                aria-label="Close navigation menu"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <nav className="mt-12 flex-1 overflow-y-auto px-6 pb-10">
              <ul className="flex flex-col gap-4">
                {navLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={handleLinkClick}
                      className="group block rounded-2xl border border-white/5 bg-white/5 px-6 py-4 text-lg font-semibold text-gray-100 shadow-lg shadow-indigo-900/20 backdrop-blur-sm transition-all duration-200 hover:border-indigo-400 hover:bg-indigo-500/15"
                    >
                      <div className="flex items-center justify-between">
                        <span>{link.label}</span>
                        <span className="text-indigo-300 transition-transform duration-200 group-hover:translate-x-1">→</span>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="px-6 pb-12">
              <a
                href="/#connect"
                onClick={handleConnectClick}
                className="flex w-full items-center justify-center rounded-2xl bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-600 py-3.5 text-base font-semibold text-white shadow-lg shadow-indigo-900/30 transition-transform duration-300 hover:scale-[1.02]"
              >
                Get a Quote
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;